import React from 'react'
import { zeroPad } from 'react-countdown'

// Components
import { Section } from '../../../components'

const TimeLeftBid = ({ timeLeft }) => {
  const renderTime = (time, styles, type) => {
    return (
      <Section className={`time-left ${styles}`}>
        <div className="time">
          <b>{time ? zeroPad(time) : '00'}</b>
        </div>
        <label>{type}</label>
      </Section>
    )
  }

  const renderSeparateTime = () => {
    return (
      <Section className="separator">
        <div className="time">:</div>
        <label />
      </Section>
    )
  }

  const timeWarning = () => {
    return timeLeft[0] === 0 && timeLeft[1] < 3 && timeLeft[2] <= 59
  }

  return (
    <>
      <Section className="bid-time-left">
        <div className="title">
          <b>Time Left</b>
        </div>
        <Section className={`time-left-group ${timeWarning() && 'time-red'}`}>
          {/*Hours*/}
          {renderTime(timeLeft[0], '', 'Hours')}
          {renderSeparateTime()}

          {/*Minutes*/}
          {renderTime(timeLeft[1], '', 'Minutes')}
          {renderSeparateTime()}

          {/*Seconds*/}
          {renderTime(timeLeft[2], '', 'Seconds')}
        </Section>
      </Section>
    </>
  )
}
export default TimeLeftBid
